const API_URL = "/api";

const APP_VERSION = "1.0";

const USER_ROLE = {
    USER: 0,
    GOD: 1,
    ADMIN: 2,
    DEPARTMENT: 3,
    DRIVER: 4,
    AIRPORT: 5,
    TRANSPORTER: 6,
    LOCAL_ADMIN: 7,
}

const USER_ROLES = {
    0: 'User',
    1: 'God',
    2: 'Administrator',
    3: 'Department Admin',
    4: 'Driver',
    5: 'Airport',
    6: 'Transporter',
    7: 'Local Admin',
}

const COLORS = [
    'f44336',
    'e91e63',
    'ff5722',
    'ff9800',
    'ffc107',
    '8bc34a',
    '4caf50',
    '00bcd4',
    '009688',
    '03a9f4',
    '3f51b5',
    '673ab7',
    '9c27b0',
    '607d8b',
    '795548',
];

const ROUTE_TYPE = {
    TRANSFER: 0,
    ARRIVAL: 1,
    DEPARTURE: 2,
    TOUR: 3,
}

const ROUTE_TYPES = {
    0: 'Transfer',
    1: 'Arrival',
    2: 'Departure',
    3: 'Tour'
}

const LOCATION_TYPE = {
    DEFAULT: 0,
    AIRPORT: 1,
    PORT: 2,
    HOTEL: 3
}

const LOCATION_TYPES = {
    0: 'Default',
    1: 'Airport',
    2: 'Port',
    3: 'Hotel'
}

const PAYMENT_TYPE = {
    ON_ACCOUNT: 0,
    CASH: 1,
    CPL: 2,
    CARD: 3,
    BANK: 4,
}

const PAYMENT_TYPES = [
    'On Account',
    'Cash',
    'CPL',
    'Credit Card',
    'Bank Deposit'
]

const CUSTOMER_TYPE = {
    GUEST: 0,
    COMPANY: 1,
    FAMILY: 2,
    INTERNET: 3,
}

const CUSTOMER_TYPES = {
    0: "Guest",
    1: "Company",
    2: "Family",
    3: "Internet",
};

const TRANSFER_STATUS = {
    OPEN: 0,
    ASSIGNED: 1,
    CLOSED: 2,
    CANCELED: 3
}

const TRANSFER_STATUSES = [
    'Open', 'Assigned', 'Closed', 'Canceled'
];

const TRANSFERS_SOURCE = {
    APP: 0,
    LINK: 1,
}

const LOCAL_STATUS = {
    OPEN: 0,
    REJECTED: 1,
    ASSIGNED: 2,
    ACCEPTED: 3,
    IN_PROGRESS: 4,
    COMPLETED: 5,
    CANCELED: 6,
};

const LOCAL_STATUSES = [
    'Open', 'Rejected', 'Assigned', 'Accepted', 'In Progress', 'Completed', 'Canceled',
];

const LOCAL_TYPE = {
    IMMEDIATE: 0,
    PREBOOKED: 1
};

const LOCAL_TYPES = [
    'Immediate',
    'Prebooked'
];


const OBJECT_TYPE = {
    COMPANY: 0,
    ACCOUNT: 1,
    DEPARTMENT: 2,
    HOTEL: 3,
    TRANSPORTER: 4,
    USER: 5,
    TRANSFER: 6,
    LOCAL: 7
}

const OBJECT_ACTION = {
    CREATE: 1,
    UPDATE: 2,
    DELETE: 3,
}

const IMAGE = {
	MAX_WIDTH: 1920,
	MAX_HEIGHT: 1440,
}

const RESERVATION_STATUS = {
    ON_PROGRESS: 0,
    NEW: 1,
    COMPLETED: 2,
    FAILED: 3,
    CANCELED: 4,
}

export {
    API_URL,
    APP_VERSION,

    USER_ROLE,
    USER_ROLES,

    COLORS,

    ROUTE_TYPE,
    ROUTE_TYPES,

    LOCATION_TYPE,
    LOCATION_TYPES,

    PAYMENT_TYPE,
    PAYMENT_TYPES,

    CUSTOMER_TYPE,
    CUSTOMER_TYPES,

    TRANSFER_STATUS,
    TRANSFER_STATUSES,
    TRANSFERS_SOURCE,

    LOCAL_STATUS,
    LOCAL_STATUSES,
    LOCAL_TYPE,
    LOCAL_TYPES,

    OBJECT_TYPE,
    OBJECT_ACTION,

    IMAGE,
    RESERVATION_STATUS,
}